import {Observable} from 'rxjs';
import {Inject, Injectable, InjectionToken, Optional} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {ConfigService} from '@services/webFeeder/config.service';
import {AppUtils} from "../../utils/app.utils";


export const USER_IDENTIFIER_INTERCEPTOR = new InjectionToken<RegExp[]>('Configuration for token interceptor');

@Injectable({
  providedIn: "root"
})
export class UserIdentifierInterceptor implements HttpInterceptor {
  list: RegExp[] = [];

  constructor(
    private _configService: ConfigService,
    @Optional() @Inject(USER_IDENTIFIER_INTERCEPTOR) list: RegExp[]) {
    if (list) {
      this.list = list;
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addUserIdentifier(request))
  }

  userIdentifierCheck($url: string): boolean {
    let returnValue = false;

    for (const i of Object.keys(this.list)) {
      if (this.list[i].exec($url) !== null) {
        returnValue = true;
        break;
      }
    }

    return returnValue;
  }

  addUserIdentifier(request) {
    let userIdentifier = this._configService.getUserIdentifier();

    if (!userIdentifier && !this.userIdentifierCheck(request.url)) {
      return request;
    }

    return request.clone({
      setHeaders: {
        'user-identifier': userIdentifier
      }
    });
  }
}
